<template>
  <BaseSection>
    <template #content>
      <div class="section__row">
        <div class="section__col">
          <Logo
            class="section__logo"
            data-animation="fadeInBottom"
            data-animation-delay="100"
          />
        </div>
        <div class="section__col section__col_middle">
          <BaseTitle
            tag="h1"
            size="l"
            is-medium
            data-animation="fadeInTop"
            data-animation-delay="300"
            class="section__title"
            text="Как стать лидером в&nbsp;сфере HR и&nbsp;увеличить EVP через заботу о&nbsp;сотрудниках"
          />
          <BaseText
            size="s"
            data-animation="fadeIn"
            data-animation-delay="600"
          >
            Бесплатный видео&#8209;курс<br> (15-20 мин.)
          </BaseText>
        </div>
      </div>
      <hr
        class="app__sep"
        data-animation="fadeIn"
        data-animation-delay="900"
      />
      <BaseTitle
        tag="h3"
        is-medium
        data-animation="fadeInBottom"
        data-animation-delay="1500"
        text="Создан в соавторстве с:"
        is-center
      />
      <div class="section__cards section__gap">
        <BaseCard
          v-for="(card, i) in cards"
          :key="`card_${card.id}`"
          v-bind="card"
          class="section__card"
          data-animation="fadeInBottom"
          :data-animation-delay="1800 + (i * 300)"
        />
      </div>
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BaseCard from '@/components/BaseCard.vue';
// import BasePoster from '@/components/BasePoster.vue';
import Logo from '@/assets/icons/logo.svg';

export default {
  name: 'IntroPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseText,
    BaseCard,
    // BasePoster,
    Logo,
  },
  staticData: () => ({
    cards: [
      {
        id: 'nornickel',
        title: 'ПАО «Норникель»',
        text: 'Крупнейший в мире производитель палладия и&nbsp;других цветных металлов, входит в&nbsp;тройку лучших работодателей России по версии Forbes',
        href: 'https://www.nornickel.ru/',
      },
      {
        id: 'gazprombank',
        title: 'АО «Газпромбанк»',
        text: 'Входит в топ&#8209;3 банков России по размеру активов в&nbsp;Центральной и&nbsp;Восточной Европе, самый привлекательный работодатель в&nbsp;сфере финансовых услуг',
        href: 'https://www.gazprombank.ru/',
      },
      {
        id: 'norbit',
        title: 'НОРБИТ (ГК ЛАНИТ)',
        text: 'Ведущий эксперт на рынке ИТ&#8209;консалтинга по разработке и&nbsp;внедрению эффективных решений для автоматизации бизнеса, входит в&nbsp;пятерку крупнейших интеграторов систем управления персоналом по версии Tadviser',
        href: 'https://www.norbit.ru/',
      },
      {
        id: 'experts',
        title: '77 experts',
        text: 'Создание рекламного и&nbsp;образовательного контента, организация и&nbsp;сопровождение офлайн- и&nbsp;онлайн&#8209;мероприятий любой сложности для внутрикорпоративных, партнерских и&nbsp;клиентских целей',
        href: 'https://77experts.com/',
      },
    ],
  }),
};
</script>
